import { H3 } from 'platform-components';
import { TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

interface Props {
    titleId: string;
}

export const CertificateModalHeader = ({ titleId }: Props) => (
    <div className="certificate-modal__header">
        <H3 id={titleId} weight={TEXT_WEIGHT.M} />
    </div>
);
